import GoogleSignInButton from "@/components/google-sign-in-button";
import AuthLayout from "@/components/layouts/auth-layout";
import LoginForm from "@/components/organisms/forms/auth/login-form";
import { __ } from "@/lib/i18n/functions";

type LoginProps = {
  resolution: Resolution;
};

const Login = ({ resolution }: LoginProps) => {
  const [route] = resolution.slugs;

  return (
    <AuthLayout route={route} locale={resolution.locale}>
      <article className="font-cabinet-grotesk text-dark-primary mx-auto mt-10 w-full max-w-[672px] space-y-6">
        <h3 className="text-2xl font-bold">{__("Already have a Festi account? Log in!", resolution.locale)}</h3>
        <GoogleSignInButton locale={resolution.locale} />
        <LoginForm locale={resolution.locale} />
      </article>
    </AuthLayout>
  );
};

export default Login;

Login.generateMetadata = async (resolution: Resolution) => {
  return {
    title: __("Login", resolution.locale),
  };
};
